import React, { Component } from "react";

export class Gallery extends Component {
  render() {
    return (
      <div id="portfolio" className="text-center portfolio-bg">
        <div className="container container-sized">
          <div className="section-title">
            <h2>Galerija proizvoda</h2>
            <p>
              Naša ponuda.
            </p>
          </div>
          <div className="row">
            <div className="portfolio-items">
              <div className="col-sm-6 col-md-4 col-lg-8">
                <div className="portfolio-item">
                  <div className="hover-bg">
                    {" "}
                    <a
                      href="img/portfolio/heading.jpg"
                      title="Licitarske zahvalnice za vjenčanje"
                      data-lightbox-gallery="gallery1"
                    >
                      <div className="hover-text">
                        <h4>Licitarske zahvalnice za vjenčanje</h4>
                      </div>
                      <img
                        src="img/portfolio/heading.jpg"
                        className="img-responsive"
                        alt="Licitarske zahvalnice za vjenčanje"
                      />{" "}
                    </a>{" "}
                  </div>
                </div>
              </div>
              
              <div className="col-sm-6 col-md-4 col-lg-4">
                <div className="portfolio-item">
                  <div className="hover-bg">
                    {" "}
                    <a
                      href="img/portfolio/christmasBox.jpg"
                      title="Božični keksi"
                      data-lightbox-gallery="gallery1"
                    >
                      <div className="hover-text">
                        <h4>Božični keksi</h4>
                      </div>
                      <img
                        src="img/portfolio/christmasBox.jpg"
                        className="img-responsive"
                        alt="Božični keksi"
                      />{" "}
                    </a>{" "}
                  </div>
                </div>
              </div>
              <div className="col-sm-6 col-md-4 col-lg-4">
                <div className="portfolio-item">
                  <div className="hover-bg">
                    {" "}
                    <a
                      href="img/portfolio/baptism2.jpg"
                      title="Medeni krevetić"
                      data-lightbox-gallery="gallery1"
                    >
                      <div className="hover-text">
                        <h4>Medeni krevetić</h4>
                      </div>
                      <img
                        src="img/portfolio/baptism2.jpg"
                        className="img-responsive"
                        alt="Medeni krevetić"
                      />{" "}
                    </a>{" "}
                  </div>
                </div>
              </div>
              <div className="col-sm-6 col-md-4 col-lg-6">
                <div className="portfolio-item">
                  <div className="hover-bg">
                    {" "}
                    <a
                      href="img/portfolio/honeyCookies.jpg"
                      title="Ukrasi od licitara"
                      data-lightbox-gallery="gallery1"
                    >
                      <div className="hover-text">
                        <h4>Medeni čajni keksi</h4>
                      </div>
                      <img
                        src="img/portfolio/honeyCookies.jpg"
                        className="img-responsive"
                        alt="Ukrasi od licitara"
                      />{" "}
                    </a>{" "}
                  </div>
                </div>
              </div>
              <div className="col-sm-6 col-md-4 col-lg-6">
                <div className="portfolio-item">
                  <div className="hover-bg">
                    {" "}
                    <a
                      href="img/portfolio/quotes.jpg"
                      title="Licitari s personaliziranom"
                      data-lightbox-gallery="gallery1"
                    >
                      <div className="hover-text">
                        <h4>Licitari s personaliziranom porukom</h4>
                      </div>
                      <img
                        src="img/portfolio/quotes.jpg"
                        className="img-responsive"
                        alt="Licitari s personaliziranom"
                      />{" "}
                    </a>{" "}
                  </div>
                </div>
              </div>
              <div className="col-sm-6 col-md-4 col-lg-12">
                <div className="portfolio-item">
                  <div className="hover-bg">
                    {" "}
                    <a
                      href="img/portfolio/toys.jpg"
                      title="Medene keksi za krstitke"
                      data-lightbox-gallery="gallery1"
                    >
                      <div className="hover-text">
                        <h4>Medene keksi za krstitke</h4>
                      </div>
                      <img
                        src="img/portfolio/toys.jpg"
                        className="img-responsive"
                        alt="Medene keksi za krstitke"
                      />{" "}
                    </a>{" "}
                  </div>
                </div>
              </div>
              <div className="col-sm-6 col-md-4 col-lg-6">
                <div className="portfolio-item">
                  <div className="hover-bg">
                    {" "}
                    <a
                      href="img/portfolio/child.jpg"
                      title="Licitari s porukom"
                      data-lightbox-gallery="gallery1"
                    >
                      <div className="hover-text">
                        <h4>Licitari s porukom</h4>
                      </div>
                      <img
                        src="img/portfolio/child.jpg"
                        className="img-responsive"
                        alt="Licitari s porukom"
                      />{" "}
                    </a>{" "}
                  </div>
                </div>
              </div>
              <div className="col-sm-6 col-md-4 col-lg-6">
                <div className="portfolio-item">
                  <div className="hover-bg">
                    {" "}
                    <a
                      href="img/portfolio/annivarsary.jpg"
                      title="Medena kutija"
                      data-lightbox-gallery="gallery1"
                    >
                      <div className="hover-text">
                        <h4>Medena kutija</h4>
                      </div>
                      <img
                        src="img/portfolio/annivarsary.jpg"
                        className="img-responsive"
                        alt="Medena kutija"
                      />{" "}
                    </a>{" "}
                  </div>
                </div>
              </div>
              <div className="col-sm-6 col-md-4 col-lg-6">
                <div className="portfolio-item">
                  <div className="hover-bg">
                    {" "}
                    <a
                      href="img/portfolio/weddingGifts4.jpg"
                      title="Medene zahvalnica za vjenčanje"
                      data-lightbox-gallery="gallery1"
                    >
                      <div className="hover-text">
                        <h4>Medene zahvalnica za vjenčanje</h4>
                      </div>
                      <img
                        src="img/portfolio/weddingGifts4.jpg"
                        className="img-responsive"
                        alt="Medene zahvalnica za vjenčanje"
                      />{" "}
                    </a>{" "}
                  </div>
                </div>
              </div>
              <div className="col-sm-6 col-md-4 col-lg-3">
                <div className="portfolio-item">
                  <div className="hover-bg">
                    {" "}
                    <a
                      href="img/portfolio/stroller.jpeg"
                      title="Medena kolica"
                      data-lightbox-gallery="gallery1"
                    >
                      <div className="hover-text">
                        <h4>Medena kolica</h4>
                      </div>
                      <img
                        src="img/portfolio/stroller.jpeg"
                        className="img-responsive"
                        alt="Medena kolica"
                      />{" "}
                    </a>{" "}
                  </div>
                </div>
              </div>

              <div className="col-sm-6 col-md-4 col-lg-3">
                <div className="portfolio-item">
                  <div className="hover-bg">
                    {" "}
                    <a
                      href="img/portfolio/everything.jpg"
                      title="Licitari s prigodnim porukama"
                      data-lightbox-gallery="gallery1"
                    >
                      <div className="hover-text">
                        <h4>Licitari s prigodnim porukama</h4>
                      </div>
                      <img
                        src="img/portfolio/everything.jpg"
                        className="img-responsive"
                        alt="Licitari s prigodnim porukama"
                      />{" "}
                    </a>{" "}
                  </div>
                </div>
              </div>             
              <div className="col-sm-6 col-md-4 col-lg-1">
                <div className="portfolio-item">
                  <div className="hover-bg">
                    {" "}
                    <a
                      href="img/portfolio/gingerbread2.jpg"
                      title="Medene kućice"
                      data-lightbox-gallery="gallery1"
                    >
                      <div className="hover-text">
                        <h4>Medene kućice</h4>
                      </div>
                      <img
                        src="img/portfolio/gingerbread2.jpg"
                        className="img-responsive"
                        alt="Medene kućice"
                      />{" "}
                    </a>{" "}
                  </div>
                </div>
              </div>
              <div className="col-sm-6 col-md-4 col-lg-2">
                <div className="portfolio-item">
                  <div className="hover-bg">
                    {" "}
                    <a
                      href="img/portfolio/friends.jpg"
                      title="Licitari s posebnom porukom"
                      data-lightbox-gallery="gallery1"
                    >
                      <div className="hover-text">
                        <h4>Licitari s posebnom porukom</h4>
                      </div>
                      <img
                        src="img/portfolio/friends.jpg"
                        className="img-responsive"
                        alt="Licitari s posebnom porukom"
                      />{" "}
                    </a>{" "}
                  </div>
                </div>
              </div>           
            </div>
          </div>
        </div> 
      </div>     
    );
  }
}

export default Gallery;
